<template>
  <v-card class="modal-tipo-calculo">
    <v-toolbar height="56" color="primary" dark flat>
      <v-toolbar-title>Tipo de Cálculo</v-toolbar-title>
    </v-toolbar>

    <v-card-text class="pa-4">
      <p class="mb-3">Defina o tipo de cálculo que será usado:</p>

      <v-layout row wrap align-center>
        <v-btn
          color="secondary"
          elevation="2"
          :outline="tipoSelecionado !== 'NORMAL'"
          @click="tipoSelecionado = 'NORMAL'"
          class="mr-2 btn-tipo-calculo"
        >
          Cálculo Normal
        </v-btn>
        <v-btn
          color="secondary"
          elevation="2"
          :outline="tipoSelecionado !== 'ESTIPULADO'"
          @click="tipoSelecionado = 'ESTIPULADO'"
          class="btn-tipo-calculo"
        >
          Cálculo Estipulado
        </v-btn>
      </v-layout>

      <v-layout v-if="tipoSelecionado === 'ESTIPULADO'" row wrap class="mt-3">
        <v-flex xs12 sm8 md6>
          <v-text-field
            v-model="valorFormatado"
            label="Valor Total Estipulado"
            placeholder="Informe o valor total estipulado"
            prefix="R$"
            @input="onValorInput"
            @blur="onValorBlur"
          />
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancelar">Cancelar</v-btn>
      <v-btn
        color="primary"
        :disabled="prosseguirDesabilitado"
        @click="confirmar"
      >
        Prosseguir
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ModalTipoCalculo",

  data() {
    return {
      tipoSelecionado: "NORMAL",
      valorPremioEstipulado: null,
      valorFormatado: ""
    };
  },

  computed: {
    prosseguirDesabilitado() {
      if (this.tipoSelecionado === "NORMAL") return false;
      return !this.valorPremioEstipulado || this.valorPremioEstipulado <= 0;
    }
  },

  methods: {
    onValorInput(valor) {
      const numerico = String(valor || "")
        .replace(/[^\d,.-]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
      const parsed = parseFloat(numerico);
      this.valorPremioEstipulado = isNaN(parsed) ? null : parsed;
    },

    onValorBlur() {
      if (this.valorPremioEstipulado != null) {
        this.valorFormatado = this.valorPremioEstipulado
          .toFixed(2)
          .replace(".", ",")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },

    confirmar() {
      this.$emit("confirmar", {
        tipoCalculo: this.tipoSelecionado,
        valorPremioEstipulado:
          this.tipoSelecionado === "ESTIPULADO"
            ? this.valorPremioEstipulado
            : null
      });
    },

    cancelar() {
      this.$emit("cancelar");
    }
  }
};
</script>

<style scoped>
.modal-tipo-calculo {
  background: #f2f2f2;
}
.btn-tipo-calculo {
  min-width: 180px;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalTipoCalculo.vue